module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "rightPanelSet",
    attrs: {
      "datas": _vm.memberInfo
    },
    on: {
      "onClose": function($event) {
        _vm.onCloseForm()
      },
      "onSubmit": function($event) {
        _vm.onChangeMember(_vm.memberInfo.id, 'setMemberForm')
      }
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Base Info")])], 1), _vm._v(" "), (_vm.memberInfo) ? _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [_c('div', {
    staticClass: "detail-wrapper"
  }, [_c('el-form', {
    ref: "setMemberForm",
    staticClass: "demo-ruleForm team-MemberForm",
    attrs: {
      "model": _vm.setMember,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    class: [1, 3].includes(_vm.$store.getters.account.is_admin) ? '' : 'fixed-text',
    attrs: {
      "label": _vm.attrText.displayNickname
    }
  }, [([1, 3].includes(_vm.$store.getters.account.is_admin)) ? _c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.setMember.name),
      callback: function($$v) {
        _vm.setMember.name = $$v
      },
      expression: "setMember.name"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.memberInfo.name))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fixed-text",
    attrs: {
      "label": _vm.attrText.account
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.memberInfo.account) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.pwd,
      "prop": "password"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.attrText.empty,
      "auto-complete": "new-password",
      "name": "new-password"
    },
    model: {
      value: (_vm.setMember.password),
      callback: function($$v) {
        _vm.setMember.password = $$v
      },
      expression: "setMember.password"
    }
  }), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_warning && _vm.company_password_strength == 1),
      expression: "show_password_warning && company_password_strength == 1"
    }]
  }, [_vm._v("The administrator has enabled the password strength setting. The password must be at least 6 characters long and must contain two of uppercase letters, lowercase letters, and special characters.")]), _vm._v(" "), _c('translate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_warning && _vm.company_password_strength == 2),
      expression: "show_password_warning && company_password_strength == 2"
    }]
  }, [_vm._v("The administrator has enabled the password strength setting. The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.repwd,
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "new-password",
      "name": "new-password-check"
    },
    model: {
      value: (_vm.setMember.checkPass),
      callback: function($$v) {
        _vm.setMember.checkPass = $$v
      },
      expression: "setMember.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select-role",
    attrs: {
      "label": _vm.attrText.role
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.memberInfo.id === _vm.$store.getters.account.id || _vm.memberInfo.account === _vm.$store.getters.team.setting.email,
      "placeholder": _vm.attrText.selectRole
    },
    model: {
      value: (_vm.setMember.is_admin),
      callback: function($$v) {
        _vm.setMember.is_admin = $$v
      },
      expression: "setMember.is_admin"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.admin,
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.optAdmin,
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.auditAdmin,
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.safeAdmin,
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.ordinary,
      "value": "0"
    }
  })], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onChangeMember(_vm.memberInfo.id, 'setMemberForm')
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanelSet.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a694a556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/team-member-setting.vue
// module id = 604
// module chunks = 4 5 6